import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';
import type {VenueRecentLocationProps} from '@Components/event-wizard/venue-recent-location/venue-recent-location.types';
import styles from './venue-recent-location.module.scss';

export function VenueRecentLocation({place, onClickPlace}: VenueRecentLocationProps): ReactElement<any> {
  const getTitle = (): string => {
    return `${place.name ?? ''} · ${place.address}`;
  };

  const onClick = (): void => {
    onClickPlace(place);
  };

  return (
    <ClickableDiv onClick={onClick} className={`${styles.recentLocationRow} _full-width flex-row-align-center radius-4 spacing-p-l-3 spacing-p-r-3`}>
      <div className="flex-row-align-center spacing-m-r-2">
        <Icon icon="icon-map-pin" size={IconSize.SIZE_ICON_16} />
      </div>
      <Text className="-truncated-text" val={getTitle()} size={TextSize.XSMALL} />
    </ClickableDiv>
  );
}
